import React, { useContext, useEffect, useState } from 'react'
import { CButton, CButtonGroup, CCol, CFormCheck, CModal, CModalBody, CRow } from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'

const RosemaryToptrendingModal = ({ componentData, modifyData, modalSpecificData, onCancel }) => {
  const { isEdit, type, cardIndex } = modalSpecificData

  const { userSessionObj } = useContext(GlobalContext)
  const [cardSize, setCardSize] = useState('md')
  const [title, setTitle] = useState('')
  const [heading, setHeading] = useState('')
  const [subHeading, setSubHeading] = useState('')
  const [paragraph, setParagraph] = useState('')
  const [imageS3key, setImageS3key] = useState('')
  const [link, setLink] = useState({ type: '', data: {} })
  const [errorData, setErrorData] = useState({})
  const [smImageData, setSmImageData] = useState([])
  const [mdImageData, setMdImageData] = useState([])
  const [lgImageData, setLgImageData] = useState([])
  const { loader, setLoader } = useContext(AppContext)

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])
  const limitValues = {
    sm: {
      heading: 50,
      subHeading: 32,
      para: 196,
    },
    md: {
      heading: 82,
      subHeading: 52,
      para: 310,
    },
    lg: {
      heading: 105,
      subHeading: 52,
      para: 420,
    },
  }

  useEffect(() => {
    const smData = [
      {
        title: '',
        id: 'smImage',
        width: 382,
        height: 597,
        divheight: '10.1rem',
        divwidth: '7.9rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '6px',
        imagePaddingY: '6px',
      },
    ]
    const mdData = [
      {
        title: '',
        id: 'mdImage',
        width: 597,
        height: 597,
        divheight: '10.1rem',
        divwidth: '10.1rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '7px',
        imagePaddingY: '7px',
      },
    ]
    const lgData = [
      {
        title: '',
        id: 'lgImage',
        width: 764,
        height: 597,
        divheight: '10.1rem',
        divwidth: '13.1rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '8px',
        imagePaddingY: '8px',
      },
    ]
    if (isEdit) {
      if (type === 'HEADING') {
        setTitle(componentData?.data?.title)
        return
      }
      let tempdata = componentData.data?.card_data

      setCardSize(tempdata[cardIndex].size)
      setHeading(tempdata[cardIndex].heading)
      setSubHeading(tempdata[cardIndex].sub_heading)
      setParagraph(tempdata[cardIndex].description)
      setImageS3key(tempdata[cardIndex].image_s3key)
      setLink(tempdata[cardIndex].link)

      if (tempdata[cardIndex].size === 'sm') {
        smData[0]['assetId'] = tempdata[cardIndex].image_s3key
        smData[0]['imageUrl'] = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          tempdata[cardIndex].image_s3key,
        )
      }
      if (tempdata[cardIndex].size === 'md') {
        mdData[0]['assetId'] = tempdata[cardIndex].image_s3key
        mdData[0]['imageUrl'] = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          tempdata[cardIndex].image_s3key,
        )
      }
      if (tempdata[cardIndex].size === 'lg') {
        lgData[0]['assetId'] = tempdata[cardIndex].image_s3key
        lgData[0]['imageUrl'] = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          tempdata[cardIndex].image_s3key,
        )
      }
    }
    setSmImageData(smData)
    setMdImageData(mdData)
    setLgImageData(lgData)
  }, [])

  const onCardSizeChange = (event) => {
    const { checked, value } = event.target
    setImageS3key('')

    const smData = [
      {
        title: '',
        id: 'smImage',
        width: 382,
        height: 597,
        divheight: '10.1rem',
        divwidth: '7.9rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '6px',
        imagePaddingY: '6px',
      },
    ]
    const mdData = [
      {
        title: '',
        id: 'mdImage',
        width: 597,
        height: 597,
        divheight: '10.1rem',
        divwidth: '10.1rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '7px',
        imagePaddingY: '7px',
      },
    ]
    const lgData = [
      {
        title: '',
        id: 'lgImage',
        width: 764,
        height: 597,
        divheight: '10.1rem',
        divwidth: '13.1rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '8px',
        imagePaddingY: '8px',
      },
    ]

    setSmImageData(smData)
    setMdImageData(mdData)
    setLgImageData(lgData)

    if (checked) {
      setCardSize(value)
    }
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    // if (title.trim().length === 0 && type === 'HEADING') {
    //   isFormValid = false
    //   temp.title = 'Heading cannot be Empty!'
    // }
    if (heading.trim().length === 0 && type === 'CARD') {
      isFormValid = false
      temp.heading = 'Heading cannot be Empty!'
    }
    if (imageS3key.trim().length === 0 && type === 'CARD') {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    if (link.type && !validateLink(link).isValid) {
      isFormValid = false
      temp.link = validateLink(link).error
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const handleSave = () => {
    if (!validateInfo()) return
    let tempdata = componentData.data
    if (type === 'CARD') {
      let elementObj = {
        image_s3key: imageS3key,
        size: cardSize,
        heading: heading,
        sub_heading: subHeading,
        description: paragraph,
        link: link,
      }

      if (!isEdit) {
        tempdata?.card_data.splice(cardIndex + 1, 0, elementObj)
      } else {
        tempdata?.card_data.splice(cardIndex, 1, elementObj)
      }

      modifyData(componentData.id, tempdata)
      return
    }

    tempdata['title'] = title

    modifyData(componentData.id, tempdata)
  }

  return (
    <CModal size="lg" className="" visible={true}>
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      {type === 'CARD' ? (
        <CModalBody className="px-5 font-13px">
          <div style={{ fontSize: '1.3rem' }} className="d-flex justify-content-center">
            <p>
              <b style={{ fontWeight: '500' }}>Card Editor</b>
            </p>
          </div>

          <CRow className="my-3">
            <CCol>
              <h6 className="font-13px">
                Select the Image size <span style={{ color: 'red' }}>*</span>
              </h6>

              <CRow className="mt-4">
                <CButtonGroup
                  id="group1"
                  role="group"
                  aria-label="Basic checkbox toggle button group"
                  style={{ fontSize: '12px' }}
                >
                  <CCol className="d-flex flex-column justify-content-center align-items-center">
                    <CFormCheck
                      type="radio"
                      id="mdCard"
                      label="597px X 597px"
                      value="md"
                      checked={cardSize === 'md'}
                      onChange={(e) => onCardSizeChange(e)}
                    />
                    {mdImageData && (
                      <ImageUploader data={mdImageData} isDisabled={cardSize !== 'md'} />
                    )}
                  </CCol>
                  <CCol className="d-flex flex-column justify-content-center align-items-center">
                    <CFormCheck
                      type="radio"
                      id="smCard"
                      label="382px X 597px"
                      value="sm"
                      checked={cardSize === 'sm'}
                      onChange={(e) => onCardSizeChange(e)}
                    />
                    {smImageData && (
                      <ImageUploader data={smImageData} isDisabled={cardSize !== 'sm'} />
                    )}
                  </CCol>
                  <CCol className="d-flex flex-column justify-content-center align-items-center">
                    <CFormCheck
                      type="radio"
                      id="lgCard"
                      label="764px X 597px"
                      value="lg"
                      checked={cardSize === 'lg'}
                      onChange={(e) => onCardSizeChange(e)}
                    />
                    {lgImageData && (
                      <ImageUploader data={lgImageData} isDisabled={cardSize !== 'lg'} />
                    )}
                  </CCol>
                </CButtonGroup>
              </CRow>
              <div className="message-text error-message">
                <p>{errorData.imageS3key}</p>
              </div>
            </CCol>
          </CRow>
          <CRow className="my-3 mt-4">
            <CCol>
              <h6 className="font-13px">
                Heading1 <span style={{ color: 'red' }}>*</span>
              </h6>
              <CustomDescriptionBox
                limit={limitValues[cardSize].heading}
                rows={1}
                value={heading}
                onChange={setHeading}
                isMandatory={true}
                errorText={errorData?.heading}
                style={{ fontSize: '13px' }}
              />
            </CCol>
          </CRow>
          <CRow className="my-3">
            <CCol>
              <h6 className="font-13px">Heading2</h6>
              <CustomDescriptionBox
                limit={limitValues[cardSize].subHeading}
                rows={1}
                value={subHeading}
                onChange={setSubHeading}
                style={{ fontSize: '13px' }}
              />
            </CCol>
          </CRow>
          <CRow className="my-3">
            <CCol>
              <h6 className="font-13px">Paragraph</h6>
              <CustomDescriptionBox
                limit={limitValues[cardSize].para}
                rows={3}
                value={paragraph}
                onChange={setParagraph}
                style={{ fontSize: '13px' }}
              />
            </CCol>
          </CRow>
          <AttachLink
            categoryData={
              categoryList
                ? categoryList?.data.filter((info, idx) => info.type === 'category' && info.status)
                : []
            }
            linkData={link}
            setLinkData={(value) => {
              clearError('link')
              setLink(value)
            }}
            astrick={true}
          />
          <div className="message-text error-message">
            <p>{errorData.link}</p>
          </div>

          <div className="mt-4 d-flex justify-content-end">
            <CButton
              style={{ color: 'black', border: '1px solid black' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton className=" bg-black rounded-1 btn-focus-none" onClick={handleSave}>
              Save
            </CButton>
          </div>
        </CModalBody>
      ) : (
        <CModalBody className="px-5">
          <div style={{ fontSize: '1.3rem' }} className="d-flex justify-content-center">
            <p>
              <b style={{ fontWeight: '500' }}>Text Editor</b>
            </p>
          </div>
          <CRow className="my-3 mt-5">
            <CCol>
              <h6 className="font-13px">Heading1</h6>
              <CustomDescriptionBox
                limit={45}
                rows={1}
                value={title}
                onChange={setTitle}
                style={{ fontSize: '13px' }}
                isMandatory={true}
                errorText={errorData.title}
              />
            </CCol>
          </CRow>
          <div className="mt-4 d-flex justify-content-end">
            <CButton
              style={{ color: 'black', border: '1px solid black' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton className=" bg-black rounded-1 btn-focus-none" onClick={handleSave}>
              Save
            </CButton>
          </div>
        </CModalBody>
      )}
    </CModal>
  )
}

export default RosemaryToptrendingModal
